<div class="d-inline-flex py-3 buscador">
  <div class="input-group flex-nowrap input-group-sm">
    <span class="input-group-text" id="addon-wrapping"
      ><i class="fa fa-search"></i
    ></span>
    <input
      pInputText
      type="text"
      class="form-control"
      placeholder="{{ 'common.search' | translate }}"
      attr.aria-label="{{ 'common.search' | translate }}"
      aria-describedby="addon-wrapping"
      (input)="applyFilterGlobal($event)"
    />
  </div>
</div>

<div class="d-inline-flex py-3 float-right">
  <div class="btn-toolbar mb-2 mb-md-0">
    <div class="btn-group">
      <a
        href="#"
        (click)="changeMapPosition()"
        class="btn btn-sm {{ classBtn1 }}"
        ><img src="assets/img/{{ img1 }}" alt=""
      /></a>
      <a
        href="#"
        (click)="changeMapPosition()"
        class="btn btn-sm {{ classBtn2 }}"
        ><img src="assets/img/{{ img2 }}" alt=""
      /></a>
    </div>
  </div>
</div>
